import {
  ArrowIcon,
  Box,
  Button,
  Flex,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
} from '@modusign/design-system';
import { ReactNode } from 'react';

import CheckIcon from './CheckIcon';

interface StartContractConfirmModalProps {
  confirmButtonLabel?: string;
  checkList: string[];
  isLoading: boolean;
  titleContent: ReactNode;
  userEmail: string;
  userName: string;
  onModalClose: () => void;
  onStartContract: () => void;
}

function StartContractConfirmModal({
  confirmButtonLabel = '서명 요청 정보 설정',
  checkList,
  isLoading,
  userEmail,
  userName,
  titleContent,
  onModalClose,
  onStartContract,
}: StartContractConfirmModalProps) {
  return (
    <>
      <Box className="Container" data-testid="startContractConfirmModal" maxWidth="xs">
        <Box className="Card Card--pop" pb={8} pt={9} px={9}>
          <ModalTitle mb={0}>{titleContent}</ModalTitle>
          <ModalContent>
            <Box
              border="1px solid"
              borderColor="cardBorderNeutralSlightlyDark"
              data-testid="start-contract-user-info"
              mb={4}
              p={6}
              sx={{ wordBreak: 'break-all' }}
              textAlign="center"
            >
              <Text as="p" fontWeight="medium">
                {userName} ({userEmail})
              </Text>
            </Box>
            <Box
              as="ul"
              bg="cardBackgroundNeutralSlightlyDark"
              border="1px solid"
              borderColor="cardBorderNeutralSlightlyDark"
              px={6}
              py={7}
            >
              {checkList.map((check, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Flex alignItems="center" as="li" key={`${index}-${check}`} mt={index > 0 ? 2 : 0}>
                  <CheckIcon />
                  <Text fontSize="md" ml={2}>
                    {check}
                  </Text>
                </Flex>
              ))}
            </Box>
          </ModalContent>
          <ModalFooter>
            <Button disabled={isLoading} type="button" onClick={onModalClose}>
              취소
            </Button>
            <Button
              isLoading={isLoading}
              ml={3}
              type="button"
              variant="primary"
              onClick={onStartContract}
            >
              <Box as="span">{confirmButtonLabel}</Box>
              <ArrowIcon direction="right" ml="2px" />
            </Button>
          </ModalFooter>
        </Box>
      </Box>
    </>
  );
}

export default StartContractConfirmModal;
